import {
  Avatar,
  Box,
  Button,
  Dialog,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Radio,
  Typography,
} from "@mui/material";
import React from "react";

import { useClientManager } from "@megaron/react-clients";

import { getSalespersonDisplayName } from "../../Home/TradeRoutesHome";
import { QueryFilters, SetQueryFilters } from "../TradeRouteDetails";

export const SelectSalespersonDialog: React.FC<{
  qs: QueryFilters;
  setQs: SetQueryFilters;
}> = ({ qs, setQs }) => {
  const [open, setOpen] = React.useState(false);

  const profilesQuery = useClientManager("auth").userProfilesQuery().useQuery({});
  const profiles = profilesQuery.data?.items;

  return (
    <>
      <Button onClick={() => setOpen(true)} sx={{ width: "100%", px: 4 }}>
        {profiles && qs.userId
          ? getSalespersonDisplayName(profiles.find((salesperson) => salesperson.legacyUserId === qs.userId)) ||
            "Nieznany Handlowiec"
          : "Brak Handlowca"}
      </Button>

      <Dialog
        open={open || qs.userId === undefined}
        fullWidth
        maxWidth="xs"
        onClose={() => qs.userId && setOpen(false)}
      >
        <Box sx={{ overflowY: "auto" }}>
          <Box p={2} pb={1}>
            <Typography variant="subtitle2">Wybierz Handlowca:</Typography>
          </Box>
          <List>
            {profiles &&
              profiles?.map((salesperson, idx) => {
                const selected = qs.userId === salesperson.legacyUserId;

                return (
                  <ListItem
                    button
                    key={salesperson.legacyUserId}
                    sx={{ backgroundColor: selected ? "#d1e6d6" : "transparent" }}
                    secondaryAction={<Radio checked={selected} sx={{ pointerEvents: "none" }} />}
                    onClick={() => {
                      setQs("userId", salesperson.legacyUserId);
                      setOpen(false);
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        alt={getSalespersonDisplayName(salesperson) || idx.toString()}
                        src={salesperson.pictureUrl ?? ""}
                      />
                    </ListItemAvatar>
                    <ListItemText>{getSalespersonDisplayName(salesperson) || "Nieznany Handlowiec"}</ListItemText>
                  </ListItem>
                );
              })}
          </List>
        </Box>
      </Dialog>
    </>
  );
};
